@if (showTurnstile) {
  <ngx-turnstile
    [siteKey]="siteKey"
    execution="render"
    appearance="execute"
    (resolved)="onResolved($event)"
    (expired)="onExpired()"
    (error)="onError()">
  </ngx-turnstile>
}